/* eslint-disable @typescript-eslint/naming-convention */
export const PageTopBannerDict = {
    DISCOUNT_BANNER: "discountBanner",
    SEASONAL_CAMPAIGN_BANNER: "seasonalCampaignBanner",
    TRIAL_BANNER: "trialBanner",
    DUNNINGS: "dunnings",
    PROJECTS_PAGE_CTA: "projectsPageCta",
    ADDON_CART: "addonsCart",
    NONE: "none",
} as const;

export type PageTopBannerType = (typeof PageTopBannerDict)[keyof typeof PageTopBannerDict];
